import styled from "styled-components"
import { Link } from "react-router-dom"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function OrderEmpty() {
  return (
    <Section>
      <IconBlock>
        <SVGIcon name="lockIcon" />
      </IconBlock>
      <Description>{`아직 주문 내역이 없어요\n제품을 구경하러 가볼까요?`}</Description>
      <Button to="/motishop">제품 구경하기</Button>
    </Section>
  )
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(100vw * (177 / 375));
`

const IconBlock = styled.div`
  width: calc(100vw * (37 / 375));
  height: calc(100vw * (40 / 375));
  margin-bottom: calc(100vw * (18 / 375));
  svg {
    path {
      color: #d8d8d8;
    }
  }
`

const Description = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23 / 375));
  text-align: center;
  color: #7f7f7f;
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (23 / 375));
`

const Button = styled(Link)`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23 / 375));
  color: #000;
  background-color: #ffcf19;
  border-radius: calc(100vw * (10 / 375));
  padding: calc(100vw * (13 / 375)) calc(100vw * (28 / 375));
`
